// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
textarea{
    resize: none !important;
}
textarea:read-only,
input:read-only {
    background: rgb(255, 255, 255, 0.1);
    font-size: 12px;
    color: var(--gray-light);
    border: 1px solid rgb(255, 255, 255, 0.1);
    font-weight: 400;
}
*:read-only:focus-visible {
    outline: none;
}

.border-grey-ligth{
    border-color: rgba(255, 255, 255, 0.7) !important;
}

.grid{
    display: grid !important;
}

.bg-transparent-opcity{
    background: rgb(255, 255, 255, 0.09);
}
.border-color-transparent-opcity{
    border-color: rgb(255, 255, 255, 0.09);
}

.corridor-button{

}
.mimetika-tooltip .p-tooltip-arrow{
    display: none;
}
.mimetika-tooltip .p-tooltip-text{
    background: transparent;
    font-size: 12px;
    color: var(--blue);
    font-weight: bold;
    box-shadow: none;

}

.icon-hover-custom{
    background: rgb(75, 196, 236, 0.11);
    border-radius: 50%;
    border-color: var(--blue);
}

.icon-hover-custom:hover{
    background: var(--blue);
    color: black;
}

@media (max-width: 768px) {
    .distances-tabs .p-tabview ul.p-tabview-nav li a.p-tabview-nav-link{
        padding: 10px 15px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/css/patient.css"],"names":[],"mappings":";AACA;IACI,uBAAuB;AAC3B;AACA;;IAEI,mCAAmC;IACnC,eAAe;IACf,wBAAwB;IACxB,yCAAyC;IACzC,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;AACxC;AACA;IACI,sCAAsC;AAC1C;;AAEA;;AAEA;AACA;IACI,aAAa;AACjB;AACA;IACI,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;;AAEpB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["\ntextarea{\n    resize: none !important;\n}\ntextarea:read-only,\ninput:read-only {\n    background: rgb(255, 255, 255, 0.1);\n    font-size: 12px;\n    color: var(--gray-light);\n    border: 1px solid rgb(255, 255, 255, 0.1);\n    font-weight: 400;\n}\n*:read-only:focus-visible {\n    outline: none;\n}\n\n.border-grey-ligth{\n    border-color: rgba(255, 255, 255, 0.7) !important;\n}\n\n.grid{\n    display: grid !important;\n}\n\n.bg-transparent-opcity{\n    background: rgb(255, 255, 255, 0.09);\n}\n.border-color-transparent-opcity{\n    border-color: rgb(255, 255, 255, 0.09);\n}\n\n.corridor-button{\n\n}\n.mimetika-tooltip .p-tooltip-arrow{\n    display: none;\n}\n.mimetika-tooltip .p-tooltip-text{\n    background: transparent;\n    font-size: 12px;\n    color: var(--blue);\n    font-weight: bold;\n    box-shadow: none;\n\n}\n\n.icon-hover-custom{\n    background: rgb(75, 196, 236, 0.11);\n    border-radius: 50%;\n    border-color: var(--blue);\n}\n\n.icon-hover-custom:hover{\n    background: var(--blue);\n    color: black;\n}\n\n@media (max-width: 768px) {\n    .distances-tabs .p-tabview ul.p-tabview-nav li a.p-tabview-nav-link{\n        padding: 10px 15px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
